import { MouseEvent } from "react"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"
import { ReactComponent as RightIcon } from "assets/svg/icon-right.svg"

interface CellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const PartnerContainer = styled.div<{ $expanded: boolean; $isChild: boolean }>`
  display: flex;
  align-items: center;
  color: var(--text-primary);
  padding-left: ${({ $isChild }) => ($isChild ? "24px" : "0")};

  svg {
    margin-right: 4px;
    fill: #64748b;
    cursor: pointer;
    transform: rotate(${({ $expanded }) => ($expanded ? "90deg" : "0deg")});
  }
`

export const PartnerCell = ({ cell: { row, getValue } }: CellProps) => {
  const title = getValue().value ? String(getValue().value) : ""

  return (
    <PartnerContainer $expanded={row.getIsExpanded()} $isChild={!!row.parentId}>
      {row.getCanExpand() && (
        <RightIcon
          onClick={(event: MouseEvent<SVGSVGElement>) => {
            event.stopPropagation()
            row.toggleExpanded()
          }}
        />
      )}
      {title}
    </PartnerContainer>
  )
}
